/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerplacehint2Inputs */

const en_organizerplacehint2 = /** @type {(inputs: Organizerplacehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A bar or another place with an address?`)
};

const de_organizerplacehint2 = /** @type {(inputs: Organizerplacehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Lokal oder ein anderer Ort mit Adresse?`)
};

/**
* | output |
* | --- |
* | "A bar or another place with an address?" |
*
* @param {Organizerplacehint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerplacehint2 = /** @type {((inputs?: Organizerplacehint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerplacehint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerplacehint2(inputs)
	return de_organizerplacehint2(inputs)
});
export { organizerplacehint2 as "organizerPlaceHint" }